import { render, staticRenderFns } from "./MainBlock.vue?vue&type=template&id=9f95646c&scoped=true&"
import script from "./MainBlock.vue?vue&type=script&lang=js&"
export * from "./MainBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f95646c",
  null
  
)

export default component.exports